import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'Alert-placeholder',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './alert-placeholder.component.html',
  styleUrls: ['./alert-placeholder.component.scss']
})
export class AlertPlaceholderComponent {

  @Input({required: true}) showAlert!: boolean;
  @Input() SubText?: string;
  @Input() alertColor:string = "alert-info";
  @Input() alertIconColor:string = 'text-info'

  constructor(){
    this.SubText = "Alert Text";
  }


}
